/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  HTTPValidationError,
} from '../models/index';
import {
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
} from '../models/index';

export interface AddVariantRequest {
    outputId: string;
    submissionId: string;
}

/**
 * 
 */
export class TestCaseOutputsApi extends runtime.BaseAPI {

    /**
     * Add a submission\'s output as a variant of a test case output and rejudge the unrecognized results. Reviewers only: organizers, and for practice submissions the organization admin or the workshop mentor of the author.
     * Add Variant
     */
    async addVariantRaw(requestParameters: AddVariantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['outputId'] == null) {
            throw new runtime.RequiredError(
                'outputId',
                'Required parameter "outputId" was null or undefined when calling addVariant().'
            );
        }

        if (requestParameters['submissionId'] == null) {
            throw new runtime.RequiredError(
                'submissionId',
                'Required parameter "submissionId" was null or undefined when calling addVariant().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/test_case_outputs/{output_id}/variants/{submission_id}`.replace(`{${"output_id"}}`, encodeURIComponent(String(requestParameters['outputId']))).replace(`{${"submission_id"}}`, encodeURIComponent(String(requestParameters['submissionId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Add a submission\'s output as a variant of a test case output and rejudge the unrecognized results. Reviewers only: organizers, and for practice submissions the organization admin or the workshop mentor of the author.
     * Add Variant
     */
    async addVariant(requestParameters: AddVariantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.addVariantRaw(requestParameters, initOverrides);
    }

}
